"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFLICTS_PAGE_SIZE = void 0;
var time_1 = require("../../../common/helpers/time");
var common_types_1 = require("../../../common/models/common-types");
exports.CONFLICTS_PAGE_SIZE = 25;
var AdminDrivesSchedulingConflictsController = /** @class */ (function () {
    function AdminDrivesSchedulingConflictsController($state, $q, DrivesModel, CoursesModel, EventsModel, drives, courses, events, FlashService) {
        this.$state = $state;
        this.$q = $q;
        this.DrivesModel = DrivesModel;
        this.CoursesModel = CoursesModel;
        this.EventsModel = EventsModel;
        this.FlashService = FlashService;
        this.goTo = this.goTo.bind(this);
        this.deleteEntity = this.deleteEntity.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.schedulingConflicts = {
            drives: {
                currentPage: 1,
                pageBy: exports.CONFLICTS_PAGE_SIZE,
                totalItems: drives.drives.total,
                data: [],
            },
            courses: {
                currentPage: 1,
                pageBy: exports.CONFLICTS_PAGE_SIZE,
                totalItems: courses.courses.total,
                data: [],
            },
            events: {
                currentPage: 1,
                pageBy: exports.CONFLICTS_PAGE_SIZE,
                totalItems: events.events.total,
                data: [],
            },
        };
        this.schedulingConflicts.drives.data = drives.drives.data.map(function (drive) {
            var _tmp = {};
            _tmp.created_at = drive.created_at;
            _tmp.id = drive.id;
            _tmp.date = (0, time_1.dateStringToDate)(drive.drive_date).toLocaleDateString("en-US");
            _tmp.instructor = { name: drive.instructor.fullname };
            _tmp.type = { name: drive.type.name };
            _tmp.start_time = (0, time_1.formatDateTime)((0, time_1.timeStringToDate)(drive.start_time), "h:mm A")
                .replace(" AM", "")
                .replace(" PM", "");
            _tmp.duration = drive.session_length / 60; // convert minutes to hours
            _tmp.notes = drive.notes;
            return _tmp;
        });
        this.schedulingConflicts.courses.data = courses.courses.data.map(function (course) {
            var _tmp = {};
            _tmp.created_at = course.created_at;
            _tmp.id = course.id;
            _tmp.date = course.date;
            _tmp.instructor = { name: course.instructor.fullname };
            _tmp.type = { name: "Course" };
            _tmp.start_time = (0, time_1.formatDateTime)((0, time_1.timeStringToDate)(course.time), "h:mm A")
                .replace(" AM", "")
                .replace(" PM", "");
            _tmp.duration = course.duration / 60; // convert minutes to hours
            _tmp.notes = course.notes;
            return _tmp;
        });
        this.schedulingConflicts.events.data = events.events.data.map(function (event) {
            var _tmp = {};
            _tmp.created_at = event.created_at;
            _tmp.id = event.id;
            _tmp.date = event.date;
            _tmp.instructor = { name: event.instructor.fullname };
            _tmp.type = { name: "Event" };
            _tmp.start_time = (0, time_1.formatDateTime)((0, time_1.timeStringToDate)(event.time), "h:mm A")
                .replace(" AM", "")
                .replace(" PM", "");
            _tmp.duration = event.duration / 60; // convert minutes to hours
            _tmp.notes = event.notes;
            return _tmp;
        });
    }
    AdminDrivesSchedulingConflictsController.prototype.goTo = function (id, type, $index) {
        if (type === "Course") {
            return this.$state.go("drivecoach.admin.courses.edit", { courseId: id });
        }
        if (type === "Event") {
            return this.$state.go("drivecoach.admin.events.edit", { eventId: id });
        }
        return this.$state.go("drivecoach.admin.drives.edit", { id: id });
    };
    AdminDrivesSchedulingConflictsController.prototype.deleteEntity = function (entity, type, $index) {
        var _this = this;
        if (type === "Course") {
            this.CoursesModel.delete(entity).then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.schedulingConflicts.courses.data.splice($index, 1);
            });
        }
        else if (type === "Event") {
            this.EventsModel.delete(entity).then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.schedulingConflicts.events.data.splice($index, 1);
            });
        }
        else {
            this.DrivesModel.deleteDrive(entity.id).then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.schedulingConflicts.drives.data.splice($index, 1);
            });
        }
    };
    AdminDrivesSchedulingConflictsController.prototype.pageChanged = function (type) {
        var _this = this;
        if (type === "drive") {
            var query = {
                paginate: "1",
                status: "Inactive - Scheduling Conflict",
                page_by: this.schedulingConflicts.drives.pageBy,
                page: this.schedulingConflicts.drives.currentPage,
            };
            this.DrivesModel.search(query).then(function (response) {
                var drives = response.drives;
                if (!(0, common_types_1.isPaginatedResponse)(drives)) {
                    return;
                }
                _this.schedulingConflicts.drives.data = drives.data.map(function (drive) {
                    var _tmp = {};
                    _tmp.created_at = drive.created_at;
                    _tmp.id = drive.id;
                    _tmp.date = (0, time_1.dateStringToDate)(drive.drive_date).toLocaleDateString("en-US");
                    _tmp.instructor = { name: drive.instructor.fullname };
                    _tmp.type = { name: drive.type.name };
                    _tmp.start_time = (0, time_1.formatDateTime)((0, time_1.timeStringToDate)(drive.start_time), "h:mm A")
                        .replace(" AM", "")
                        .replace(" PM", "");
                    _tmp.duration = drive.session_length / 60; // convert minutes to hours
                    _tmp.notes = drive.notes;
                    return _tmp;
                });
                _this.schedulingConflicts.drives.currentPage = drives.current_page;
                _this.schedulingConflicts.drives.totalItems = drives.total;
            });
        }
        if (type === "courses") {
            var query = {
                paginate: true,
                status: "Inactive - Scheduling Conflict",
                page_by: this.schedulingConflicts.courses.pageBy,
                page: this.schedulingConflicts.courses.currentPage,
            };
            this.CoursesModel.search(query).then(function (response) {
                _this.schedulingConflicts.courses.data = response.courses.data.map(function (course) {
                    var _tmp = {};
                    _tmp.created_at = course.created_at;
                    _tmp.id = course.id;
                    _tmp.date = course.date;
                    _tmp.instructor = { name: course.instructor.fullname };
                    _tmp.type = { name: "Course" };
                    _tmp.start_time = (0, time_1.formatDateTime)((0, time_1.timeStringToDate)(course.time), "h:mm A")
                        .replace(" AM", "")
                        .replace(" PM", "");
                    _tmp.duration = course.duration / 60; // convert minutes to hours
                    _tmp.notes = course.notes;
                    return _tmp;
                });
                _this.schedulingConflicts.courses.currentPage =
                    response.courses.current_page;
                _this.schedulingConflicts.courses.totalItems = response.courses.total;
            });
        }
        if (type === "events") {
            var query = {
                paginate: "1",
                status: "Inactive - Scheduling Conflict",
                page_by: this.schedulingConflicts.events.pageBy,
                page: this.schedulingConflicts.events.currentPage,
            };
            this.EventsModel.search(query).then(function (response) {
                var events = response.events;
                if (!(0, common_types_1.isPaginatedResponse)(events)) {
                    return;
                }
                _this.schedulingConflicts.events.data = events.data.map(function (event) {
                    var _tmp = {};
                    _tmp.created_at = event.created_at;
                    _tmp.id = event.id;
                    _tmp.date = event.date;
                    _tmp.instructor = { name: event.instructor.fullname };
                    _tmp.type = { name: "Event" };
                    _tmp.start_time = (0, time_1.formatDateTime)(event.time instanceof Date
                        ? event.time
                        : (0, time_1.timeStringToDate)(event.time), "h:mm A")
                        .replace(" AM", "")
                        .replace(" PM", "");
                    _tmp.duration = event.duration / 60; // convert minutes to hours
                    _tmp.notes = event.notes;
                    return _tmp;
                });
                _this.schedulingConflicts.events.currentPage = events.current_page;
                _this.schedulingConflicts.events.totalItems = events.total;
            });
        }
    };
    return AdminDrivesSchedulingConflictsController;
}());
AdminDrivesSchedulingConflictsController.$inject = [
    "$state",
    "$q",
    "DrivesModel",
    "CoursesModel",
    "EventsModel",
    "drives",
    "courses",
    "events",
    "FlashService",
];
exports.default = AdminDrivesSchedulingConflictsController;
